import { useMemo } from "react";
import { Trophy, X } from "lucide-react";

export const CUSTOMER_WELCOME_KEY = "arctic_customer_welcome";

export default function CustomerWelcomeCard({ user, onClose, onPassport, onBrowse }) {
  const firstName = useMemo(() => {
    const value = String(user?.name || "").trim();
    return value ? value.split(/\s+/)[0] : "there";
  }, [user?.name]);

  return (
    <aside
      className="fixed inset-x-4 bottom-28 z-[60] mx-auto max-w-lg rounded-3xl border border-[#d9d3f4] bg-white p-5 shadow-[0_24px_70px_-20px_rgba(16,35,63,0.45)] md:bottom-6"
      role="status"
      aria-live="polite"
      data-testid="customer-welcome-card"
    >
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#f3efff] text-[#6d28d9]">
          <Trophy size={20} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-3">
            <div>
              <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#6d28d9]">Welcome to Arctic Plate</div>
              <h2 className="mt-1 font-serif text-2xl font-semibold text-[#10233f]">Thanks for signing up, {firstName}!</h2>
            </div>
            <button type="button" onClick={onClose} className="rounded-full p-2 text-[#667085] hover:bg-[#f8fafc]" aria-label="Close welcome message">
              <X size={17} />
            </button>
          </div>
          <p className="mt-3 text-sm leading-6 text-[#667085]">
            Every completed local order moves your <strong className="text-[#10233f]">Local Passport</strong> forward:
            Local Explorer starts at 1 order, Local Regular at 5, Alaska Food Supporter at 10, and Local Champion at 20.
            Trying different Alaska food businesses and leaving verified reviews can unlock extra badges. The Passport is recognition only and has no cash value.
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button type="button" onClick={onPassport} className="min-h-11 rounded-xl bg-[#6d28d9] px-4 text-xs font-bold text-white">
              View Local Passport
            </button>
            <button type="button" onClick={onBrowse} className="min-h-11 rounded-xl border border-[#d8deea] bg-white px-4 text-xs font-semibold text-[#10233f]">
              Start exploring
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
}
